module.exports = "/React/dist/10b6d63bc9b0fdd505f424794a9048d4.jpg";